export default __webpack_public_path__ + "static/media/CommonBanner.f09cf77a.png";